import { createFileRoute } from '@tanstack/react-router'
import { OpenTransportDocumentsPage } from 'pages/app/open-transport-documents-page/OpenTransportDocumentsPage'

export const Route = createFileRoute('/_authenticated/app/transport-sedlar')({
  component: OpenTransportDocumentsPage,
})
